(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faqs-group"] && !Shopify.designMode) return;
  try {
    (() => {
    /**
     * FAQ Groups behavior
     * -------------------
     * There are three UI states per section:
     * 1) All topics visible (default)
     * 2) A topic expanded via "View All" (shows heading + full list)
     * 3) A question selected (shows only Q/A detail + back button)
     *
     * State is stored on data attributes + URL params for deep linking.
     */

    // ---------- Utilities ----------
    const toArray = (nodeList) => Array.from(nodeList || []);
    const toInt = (value) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const QUERY = {
      group: 'faqs-group',
      question: 'question',
      viewAll: 'view-all',
    };

    const getSection = (root) => root.closest('[data-faqs-groups-section]');
    const getTopics = (section) => toArray(section.querySelectorAll('[data-faq-topic]'));

    const getTopicEntries = (root) => toArray(root.querySelectorAll('.faq-topic__content .faq-item-list'));

    const getEntryQuestionSource = (entry) => entry.querySelector('.faq-item-list__content > :first-child');

    const getEntryAnswerSource = (entry) => entry.querySelector('.faq-item-list__content > :nth-child(2)');

    const getTopicIndex = (section, topic) => {
      const topics = getTopics(section);
      const index = topics.indexOf(topic);
      return index === -1 ? null : index + 1;
    };

    const getEntryIndex = (topic, entry) => {
      const entries = getTopicEntries(topic);
      const index = entries.indexOf(entry);
      return index === -1 ? null : index + 1;
    };

    const getTopicByIndex = (section, index) => {
      if (!index) return null;
      const topics = getTopics(section);
      return topics[index - 1] || null;
    };

    const getEntryByIndex = (topic, index) => {
      if (!index) return null;
      const entries = getTopicEntries(topic);
      return entries[index - 1] || null;
    };

    // ---------- Back Button ----------
    const getBackButton = (section) => {
      if (!section) return null;

      // Prefer a dedicated back button if already present.
      const existingButton = section.querySelector('[data-faq-go-back]');
      if (existingButton) return existingButton;

      // Otherwise, try to re-use a section CTA and move it into the action slot.
      const actions = section.querySelector('.faqs-groups-section__actions');
      const candidate = section.querySelector(
        '.faqs-groups-section__inner > a.button, .faqs-groups-section__inner > a.button-secondary, .faqs-groups-section__inner > a.link'
      );

      if (!actions || !candidate) return null;

      candidate.dataset.faqGoBack = '';
      candidate.classList.add('faqs-groups-section__back');
      candidate.hidden = true;
      actions.appendChild(candidate);

      return candidate;
    };

    const updateBackButton = (section, isActive) => {
      const backButton = getBackButton(section);
      if (!backButton) return;
      backButton.hidden = !isActive;
    };

    // ---------- Detail Rendering ----------
    const renderSelectedEntry = (root, entry) => {
      const detail = root.querySelector('[data-faq-topic-detail]');
      const questionTarget = root.querySelector('[data-faq-topic-detail-question]');
      const answerTarget = root.querySelector('[data-faq-topic-detail-answer]');

      if (!detail || !questionTarget || !answerTarget) return;

      questionTarget.innerHTML = '';
      answerTarget.innerHTML = '';

      if (!entry) {
        detail.hidden = true;
        return;
      }

      const questionSource = getEntryQuestionSource(entry);
      const answerSource = getEntryAnswerSource(entry);

      if (!questionSource || !answerSource) {
        detail.hidden = true;
        return;
      }

      // Clone DOM so the list remains intact.
      questionTarget.appendChild(questionSource.cloneNode(true));
      answerTarget.appendChild(answerSource.cloneNode(true));
      detail.hidden = false;
    };

    // ---------- Topic UI Refresh ----------
    const refreshTopic = (root) => {
      if (!root) return;

      const content = root.querySelector('.faq-topic__content');
      if (!content) return;

      const entryPlaceholder = root.querySelector('[data-faq-topic-entry-placeholder]');
      const footer = root.querySelector('[data-faq-topic-footer]');
      const viewAllButton = root.querySelector('[data-faq-topic-view-all]');
      const focusLayout = root.querySelector('[data-faq-topic-focus-layout]');

      const selectedQuestionIndex = toInt(root.dataset.faqSelectedQuestionIndex || '');
      const entryBlocks = getTopicEntries(root);
      const visibleLimit = Number(root.dataset.visibleLimit || 5);
      const isExpanded = root.dataset.faqTopicExpanded === 'true';
      const hasOverflow = entryBlocks.length > visibleLimit;

      const activeEntry = getEntryByIndex(root, selectedQuestionIndex);

      const isQuestionSelected = Boolean(activeEntry);

      if (entryPlaceholder) {
        entryPlaceholder.hidden = entryBlocks.length > 0;
      }

      // Hide the full topic content when showing a single Q/A detail.
      if (content) {
        content.hidden = isQuestionSelected;
      }

      // List visibility rules:
      // - Question selected: hide entire list
      // - Expanded: show all entries
      // - Default: show only up to the visible limit
      entryBlocks.forEach((entry, index) => {
        if (isQuestionSelected) {
          entry.hidden = true;
        } else if (isExpanded) {
          entry.hidden = false;
        } else {
          entry.hidden = index >= visibleLimit;
        }

        entry.classList.toggle('is-active', entry === activeEntry);
      });

      // View all CTA only when there is overflow and user is in default view.
      if (footer) {
        footer.hidden = !hasOverflow || isExpanded || isQuestionSelected;
      }
      if (viewAllButton) {
        viewAllButton.hidden = !hasOverflow || isExpanded || isQuestionSelected;
      }

      // Detail layout only when a question is selected.
      if (focusLayout) {
        focusLayout.hidden = !isQuestionSelected;
      }

      renderSelectedEntry(root, activeEntry);
    };

    // ---------- State Sync ----------
    const syncSectionState = (
      section,
      activeTopicIndex,
      activeQuestionIndex,
      { push = true, viewAll = false } = {}
    ) => {
      if (!section) return;

      const topics = getTopics(section);

      updateBackButton(section, Boolean(activeTopicIndex));
      section.dataset.faqQuestionActive = activeQuestionIndex ? 'true' : 'false';

      if (!activeTopicIndex) {
        // Reset to default: show all topics
        topics.forEach((topic) => {
          topic.hidden = false;
          topic.dataset.faqTopicExpanded = 'false';
          topic.dataset.faqSelectedQuestionIndex = '';
          refreshTopic(topic);
        });
      } else {
        // Show only the active topic (expanded or question-selected)
        topics.forEach((topic) => {
          const isActive = getTopicIndex(section, topic) === activeTopicIndex;
          topic.hidden = !isActive;
          topic.dataset.faqTopicExpanded = isActive && !activeQuestionIndex && viewAll ? 'true' : 'false';
          topic.dataset.faqSelectedQuestionIndex = isActive ? activeQuestionIndex || '' : '';
          refreshTopic(topic);
        });
      }

      if (!push) return;

      // Update URL params for deep linking and history navigation.
      const url = new URL(window.location.href);

      if (activeTopicIndex) {
        url.searchParams.set(QUERY.group, String(activeTopicIndex));
      } else {
        url.searchParams.delete(QUERY.group);
      }

      if (activeQuestionIndex) {
        url.searchParams.set(QUERY.question, String(activeQuestionIndex));
      } else {
        url.searchParams.delete(QUERY.question);
      }

      if (activeTopicIndex && viewAll && !activeQuestionIndex) {
        url.searchParams.set(QUERY.viewAll, 'yes');
      } else {
        url.searchParams.delete(QUERY.viewAll);
      }

      window.history.pushState({ activeTopicIndex }, '', url);
    };

    const applySectionFromUrl = (section) => {
      if (!section) return;

      const url = new URL(window.location.href);
      const activeTopicIndex = toInt(url.searchParams.get(QUERY.group));
      const activeQuestionIndex = toInt(url.searchParams.get(QUERY.question));
      const viewAll = (url.searchParams.get(QUERY.viewAll) || '').toLowerCase() === 'yes';

      if (!activeTopicIndex) {
        syncSectionState(section, '', '', { push: false });
        return;
      }

      const activeTopic = getTopicByIndex(section, activeTopicIndex);

      if (!activeTopic) {
        syncSectionState(section, '', '', { push: false });
        return;
      }

      const entries = getTopicEntries(activeTopic);
      const hasQuestionMatch = !activeQuestionIndex || entries[activeQuestionIndex - 1];

      syncSectionState(section, activeTopicIndex, hasQuestionMatch ? activeQuestionIndex : '', {
        push: false,
        viewAll: viewAll,
      });
    };

    // ---------- Event Binding ----------
    const initTopic = (root) => {
      if (!root) return;

      const viewAllButton = root.querySelector('[data-faq-topic-view-all]');
      const entryBlocks = getTopicEntries(root);

      refreshTopic(root);

      // Bind "View All" once per topic.
      if (viewAllButton && root.dataset.faqTopicBound !== 'true') {
        root.dataset.faqTopicBound = 'true';
        viewAllButton.addEventListener('click', () => {
          const section = getSection(root);
          const topicIndex = getTopicIndex(section, root);
          syncSectionState(section, topicIndex, '', { viewAll: true });
        });
      }

      // Bind each FAQ item as a button (click + Enter/Space).
      entryBlocks.forEach((entry) => {
        if (entry.dataset.faqEntryBound === 'true') return;
        entry.dataset.faqEntryBound = 'true';
        entry.tabIndex = 0;
        entry.setAttribute('role', 'button');

        const selectEntry = () => {
          const section = getSection(root);
          const topicIndex = getTopicIndex(section, root);
          const entryIndex = getEntryIndex(root, entry);
          syncSectionState(section, topicIndex, entryIndex, { viewAll: false });
        };

        entry.addEventListener('click', selectEntry);
        entry.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          selectEntry();
        });
      });
    };

    const initAll = (scope = document) => {
      toArray(scope.querySelectorAll('[data-faqs-groups-section]')).forEach((section) => {
        getBackButton(section);
        getTopics(section).forEach(initTopic);
        applySectionFromUrl(section);

        const backButton = getBackButton(section);
        if (backButton && section.dataset.faqBackBound !== 'true') {
          section.dataset.faqBackBound = 'true';
          backButton.addEventListener('click', (event) => {
            event.preventDefault();
            syncSectionState(section, '', '');
          });
        }
      });
    };

    // ---------- Boot ----------
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    // Shopify theme editor hooks
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      initAll(event.target.closest('.shopify-section') || document);
    });

    // Handle browser back/forward
    window.addEventListener('popstate', () => {
      initAll(document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["new-collection-filter"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__newCollectionFilterBound) return;
    window.__newCollectionFilterBound = true;

    const OPEN_CLASS = 'new-collection-filter-open';
    let isOpen = false;

    const syncUI = () => {
      const roots = document.querySelectorAll('[data-new-collection-filter]');
      roots.forEach((root) => {
        const wrapper = root.closest('.collection-wrapper');
        const toggle = root.querySelector('[data-new-filter-toggle]');
        const toggleLabel = root.querySelector('[data-new-filter-toggle-label]');
        const sidebar = root.querySelector('[data-new-filter-sidebar]');
        const breakpoint = Number(root.dataset.breakpoint || 992);
        const openLabel = root.dataset.openLabel || 'Filter';
        const closeLabel = root.dataset.closeLabel || 'Hide filters';
        const desktop = window.innerWidth >= breakpoint;

        if (wrapper) wrapper.classList.toggle(OPEN_CLASS, isOpen);
        if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (toggleLabel) toggleLabel.textContent = isOpen ? closeLabel : openLabel;
        if (sidebar) sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        if (!desktop && isOpen) {
          document.documentElement.classList.add('new-filter-lock-scroll');
        } else {
          document.documentElement.classList.remove('new-filter-lock-scroll');
        }
      });
    };

    const setOpenState = (open) => {
      isOpen = open === true;
      syncUI();
    };

    setOpenState(false);

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('[data-new-filter-toggle]')) {
        setOpenState(!isOpen);
        return;
      }

      if (target.closest('[data-new-filter-close]')) {
        setOpenState(false);
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpenState(false);
      }
    });

    window.addEventListener('resize', syncUI);

    // ========== Category tabs logic ==========
    function initCategoryTabs(blockRoot) {
      // Find the Category filter details element
      const summaryLabels = blockRoot.querySelectorAll('.new-collection-filter__facet .new-collection-filter__summary-label');
      let categoryFacet = null;
      for (let label of summaryLabels) {
        if (label.textContent.trim() === 'Category') {
          categoryFacet = label.closest('.new-collection-filter__facet');
          break;
        }
      }
      if (!categoryFacet) return; // no Category filter

      const categoryCheckboxes = categoryFacet.querySelectorAll('input[type="checkbox"]');
      const tabs = blockRoot.querySelectorAll('.new-collection-filter__categories .new-collection-filter__link');
      const allTab = Array.from(tabs).find(tab => tab.textContent.trim() === 'All');
      const categoryTabs = Array.from(tabs).filter(tab => tab !== allTab);

      // Helper to update active classes on tabs based on checked checkboxes
      function updateTabActiveState() {
        const checkedValues = Array.from(categoryCheckboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.closest('label')?.querySelector('span')?.textContent.trim() || '');

        if (allTab) {
          if (checkedValues.length === 0) {
            allTab.classList.add('is-active');
          } else {
            allTab.classList.remove('is-active');
          }
        }

        categoryTabs.forEach(tab => {
          const tabText = tab.textContent.trim();
          if (checkedValues.includes(tabText)) {
            tab.classList.add('is-active');
          } else {
            tab.classList.remove('is-active');
          }
        });
      }

      // Initial update
      updateTabActiveState();

      // Listen for checkbox changes (from sidebar or clear button)
      categoryFacet.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          updateTabActiveState();
        }
      });

      // Handle tab clicks
      if (allTab) {
        allTab.addEventListener('click', (e) => {
          e.preventDefault();
          categoryCheckboxes.forEach(cb => {
            if (cb.checked) {
              cb.checked = false;
              cb.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      categoryTabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const tabText = tab.textContent.trim();

          let targetCheckbox = null;
          for (let cb of categoryCheckboxes) {
            const labelSpan = cb.closest('label')?.querySelector('span');
            if (labelSpan && labelSpan.textContent.trim() === tabText) {
              targetCheckbox = cb;
              break;
            }
          }
          if (!targetCheckbox) return;

          categoryCheckboxes.forEach(cb => {
            const shouldCheck = (cb === targetCheckbox);
            if (cb.checked !== shouldCheck) {
              cb.checked = shouldCheck;
              cb.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    }

    // Re-run for all blocks (e.g., after AJAX update)
    function reinitAllCategoryTabs() {
      document.querySelectorAll('[data-new-collection-filter]').forEach(initCategoryTabs);
    }

    // Listen for facet update event (common in Shopify AJAX filters)
    document.addEventListener('facet:updated', reinitAllCategoryTabs);
    // Also listen for a general AJAX completion event (fallback)
    document.addEventListener('ajaxSuccess', reinitAllCategoryTabs);

    // MutationObserver fallback: watch each block for content changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          // Debounce to avoid excessive calls
          clearTimeout(window.__facetUpdateTimeout);
          window.__facetUpdateTimeout = setTimeout(reinitAllCategoryTabs, 100);
        }
      });
    });

    // Start observing each block after DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
      const blocks = document.querySelectorAll('[data-new-collection-filter]');
      blocks.forEach(block => {
        observer.observe(block, { childList: true, subtree: true });
        initCategoryTabs(block); // first run
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-custom-buttons"] && !Shopify.designMode) return;
  try {
    const productsPartsSection = document.querySelector('.product-parts-section');
  const productsPartsSectionId = productsPartsSection.getAttribute('id');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-media"] && !Shopify.designMode) return;
  try {
    // document.addEventListener('mouseover', (event) => {
  //   const thumb = event.target.closest('[data-collection-images-thumb]');
  //   if (!thumb || thumb.dataset.preloaded === 'true') return;

  //   const src = thumb.getAttribute('data-main-src');
  //   if (!src) return;

  //   const img = new Image();
  //   img.src = src;

  //   thumb.dataset.preloaded = 'true';
  // });

  const preloadImages = () => {
  const thumbs = document.querySelectorAll('[data-collection-images-thumb]');

  thumbs.forEach((thumb) => {
    const src = thumb.getAttribute('data-main-src');
    if (!src) return;

    const img = new Image();
    img.src = src;
    });
  };
  preloadImages();

  (() => {
    if (window.__collectionImagesBlockInitialized) return;
    window.__collectionImagesBlockInitialized = true;

    document.addEventListener('click', (event) => {
      const moreButton = event.target.closest('[data-collection-images-more]');
      if (moreButton) {
        const blockRoot = moreButton.closest('[data-collection-images]');
        if (!blockRoot) return;

        const hiddenThumbs = blockRoot.querySelectorAll('[data-collection-images-thumb-hidden]');
        hiddenThumbs.forEach((thumb) => {
          thumb.classList.remove('is-hidden');
          thumb.removeAttribute('data-collection-images-thumb-hidden');
        });

        moreButton.remove();
        return;
      }

      const thumb = event.target.closest('[data-collection-images-thumb]');
      if (!thumb) return;

      const blockRoot = thumb.closest('[data-collection-images]');
      if (!blockRoot) return;

      const mainImage = blockRoot.querySelector('[data-collection-images-main]');
      if (!mainImage) return;

      const newSrc = thumb.getAttribute('data-main-src');
      const newAlt = thumb.getAttribute('data-main-alt') || mainImage.alt;

      if (newSrc) {
        mainImage.src = newSrc;
        mainImage.alt = newAlt;
      }

      const allThumbs = blockRoot.querySelectorAll('[data-collection-images-thumb]');
      allThumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
